import React from 'react';
import {
  FooterBlockWrapper,
  FooterWrapper,
  FooterWrapperChild,
} from '@app/ui/pages/landing-page/footer/footer.styles';
import { FooterInfo } from '@app/ui/pages/landing-page/footer/info/footer-info.components';
import { Link, Typography } from '@mui/material';
import { BreakLine } from '@app/ui/pages/landing-page/landing-page.styles';
import docAbout from '@app/assets/docs/about.pdf';
import docOffer from '@app/assets/docs/public-offer.pdf';
import {
  PHONE_FOR_CALL,
  PHONE_FOR_CALL_SECOND,
  PROVIDER_SUPPORT_EMAIL,
} from '@app/ui/common/common.constants';
import { TELEGRAM_BOT, TELEGRAM_BOT_NAME } from '@app/config';
import { shouldShowMainPhone } from '@app/utils/domainHelpers';

export const Footer: React.FC = () => {
  // Основной телефон показываем только на ok-telecom.ru
  const showMainPhone = shouldShowMainPhone();

  return (
    <FooterWrapper>
      <FooterWrapperChild>
        <FooterInfo />
        <FooterBlockWrapper>
          <Typography variant='h6'> Услуги </Typography>
          <BreakLine />
          <Typography variant='body1'> Интернет </Typography>
          <Typography variant='body1'> IPTV </Typography>
          {/* <Typography variant='body1'> Видеодомофон </Typography> */}
        </FooterBlockWrapper>
        <FooterBlockWrapper>
          <Typography variant='h6'> О Компании </Typography>
          <BreakLine />
          <Link href={docAbout} target='blank'>
            <Typography variant='body1'> О Нас </Typography>
          </Link>
          <Link href={docOffer} target='blank'>
            <Typography variant='body1'> Оферта </Typography>
          </Link>
        </FooterBlockWrapper>
        <FooterBlockWrapper>
          <Typography variant='h6'> Контакты </Typography>
          <BreakLine />
          {showMainPhone && (
            <Typography variant='body1'>
              Тех. поддержка: {PHONE_FOR_CALL}
            </Typography>
          )}
          <Typography variant='body1'>
            Тех. поддержка: {PHONE_FOR_CALL_SECOND}
          </Typography>
          {/* <Typography variant='body1'>
            E-mail: {PROVIDER_SUPPORT_EMAIL}
          </Typography> */}
          {/* На доменах без основного телефона (не ok-telecom.ru) показываем
              ссылку на Telegram-бота вместо скрытого номера */}
          {!showMainPhone && TELEGRAM_BOT_NAME && (
            <Link href={TELEGRAM_BOT} target='blank' underline='hover'>
              <Typography variant='body1'>
                Telegram бот: {TELEGRAM_BOT_NAME.toLowerCase()}
              </Typography>
            </Link>
          )}
        </FooterBlockWrapper>
      </FooterWrapperChild>
    </FooterWrapper>
  );
};
